import { IExecutionOptions, IQueryOptions } from '../../models/query';
import { BaseTransform } from './BaseTransform';

export class RenameFieldTransform extends BaseTransform {
	execute(queryResponse: any, queryOptions: IQueryOptions, executionOptions: IExecutionOptions) {
		const response: any = queryResponse;
		if (queryResponse && typeof queryResponse === 'object') {
			const { renameFieldOptions } = this.options;
			if (renameFieldOptions) {
				const { original, replacement } = renameFieldOptions;
				if (original && replacement && queryResponse.hasOwnProperty(original)) {
					queryResponse[replacement] = queryResponse[original];
					delete queryResponse[original];
				}
			}
		}
		return response;
	}
}